import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  SxProps,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IControlledRadioButtons {
  title: string;
  titleSx?: SxProps;
  radioColor?: string;
  isDirectionRow: boolean;
  radioGroupSx?: SxProps;
  values: string[];
  valueSx?: SxProps;
  onChange: Function;
  ariaDescribedBy?: string;
}

export const ControlledRadioButtons = ({
  title,
  titleSx,
  isDirectionRow = true,
  radioColor,
  radioGroupSx,
  values,
  valueSx,
  onChange,
  ariaDescribedBy,
}: IControlledRadioButtons) => {
  const isDesktop = useIsDesktop();

  const groupId = `checkbox-group-${title.trim().replace(' ', '-')}`;

  return (
    <FormControl>
      <FormLabel
        sx={{
          mb: isDesktop ? '18px' : '14px',
          color: 'inherit',
          fontWeight: 700,
          fontSize: isDesktop ? '20px' : '18px',
          lineHeight: '24px',
          textAlign: 'center',
          fontFamily: 'inherit',
          ...titleSx,
        }}
        id={groupId}
      >
        {title}
      </FormLabel>
      <RadioGroup
        aria-label={title}
        aria-describedby={ariaDescribedBy}
        defaultValue={values[0]}
        row={isDirectionRow}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value)
        }
        sx={{
          gap: '20px',
          ...radioGroupSx,
        }}
      >
        {values.map((value: string, index: number) => {
          return (
            <FormControlLabel
              aria-labelledby={groupId}
              key={index}
              value={value}
              control={
                <Radio
                  inputProps={{ 'aria-label': value }}
                  sx={{
                    padding: 0,
                    margin: 0,
                    color: radioColor || '#A020FF',
                    '&.Mui-checked': {
                      color: radioColor || '#A020FF',
                    },
                    '& label': {
                      margin: 0,
                    },
                  }}
                />
              }
              label={value}
              sx={{
                gap: '7px',
                '& .muirtl-1497ugp-MuiTypography-root': {
                  fontWeight: 600,
                  fontSize: isDesktop ? '18px' : '16px',
                  lineHeight: '24px',
                  fontFamily: 'inherit',
                },
                ...valueSx,
              }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
